import { createError } from '#imports';

export default class ErrorHelper {
  static throwInvalidTokenError(e: unknown) {
    const suffix = e instanceof Error ? ` Message: ${e.message}` : '';
    this.throwError(403, `Invalid token. Please log in.${suffix}`);
  }

  static throwError(statusCode: number, statusMessage: string) {
    throw createError({ statusCode, statusMessage })
  }
}
